import { fetchCart, addProductToCart, deleteProductFromCart, setProductQuantity, postGroupDelivery, postGroupOptimise } from '../../network/cartRequests'

// initial state
const state = {
	cart: null
}

// getters
/*cart comes as a structure of freight_group_key : {
	items: {
		freight_group_key:{
			items:{
				item_id: {
					product: productObj,
					settings{
						quantity: x,
						delivery: x,
						optimise: x
					}
		
				}
				item_id: ...
			}
			freight:{
				total:  x,
				messages: [
					x
				]
			},
			settings:{
				delivery: [{name: "Home Delivery", value: "home", info: optional}],
				optimise:
			},
			available_settings:{
				optimise: false/true,
				delivery:  
			}
		}
	}
	],
}
}*/
const getters = {
	//flatten out items into a map of product_id to product & settings
	listItems: state => {
		if (!state.cart || !state.cart.groups) return {}

		let allItems = {};

		for (let group of Object.values(state.cart.groups)) {
			for(let [productId, item] of Object.entries(group.items)){
				allItems[productId] = item;
			}
		}
		return allItems
	},
	itemCount: (state, getters) => {
		var sum = 0

		for(let item of Object.values(getters.listItems)){
			sum += parseInt(item.settings.quantity);
		}
		return sum
	},
	inCart: (state, getters) => itemId => {
		itemId = parseInt(itemId)
		
		if(itemId in getters.listItems){
			return parseInt(getters.listItems[itemId].settings.quantity)
		}
		return 0
	}
}

// actions
const actions = {
	//retrieves cart from server
	getCart({ commit }) {
		return new Promise((resolve, reject) => {
			fetchCart((cart) => {
				commit('setCartItems', cart)
				resolve() //calls then
			},
			errorMessage => {
				//TODO what to do on cart fetch fail
				reject(errorMessage) //calls 'catch'
			})
		})
	},

	//Checks that the cart has been fetched from the server
	ensureCartValid({ state, dispatch }) {
		if (state.cart) return Promise.resolve(state.cart)

		return dispatch("getCart");
	},

	// addItem action computes new cart with added item
	// or incremented quantity
	// then dispatches saveCart action
	addItem({commit}, { productId, quantity = 1}) {
		addProductToCart(productId, quantity).then(newCart => {
			commit('setCartItems', newCart)
		})
	},
	// remove item from new cart
	// dispatch saveCart action
	removeItem({ commit }, { productId }) {
		deleteProductFromCart(productId).then(newCart =>{
			commit('setCartItems', newCart);
		})
	},

	setQuantity({commit}, {productId, quantity}){
		setProductQuantity(productId, quantity).then(newCart =>{
			commit('setCartItems', newCart);
		})
	},

	//delivery options are per group of items, so send group if through with new setting
	setGroupDelivery({commit}, {groupId, delivery}){
		postGroupDelivery(groupId, delivery).then(newCart =>{
			commit('setCartItems', newCart);
		})
	},

	//optimise settings are per group of items
	setGroupOptimise({commit}, {groupId, optimise}){
		postGroupOptimise(groupId, optimise).then(newCart =>{
			commit('setCartItems', newCart);
		})
	},

}

// mutations
const mutations = {
	setCartItems(state, cartValue) {
		state.cart = Object.assign({}, cartValue)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}